import request from '@/utils/request'

export function simpleUploader(file, dataType, fileType) {
  var dataList = new FormData();
  dataList.append(file.name, file.raw);
  dataList.append("fileType", fileType || "excel");
  dataList.append("dataType", dataType || "simpleUploader");

  return request({
    url: 'BaseUploader/Simple',
    method: 'post',
    data: dataList,
    loadTarget: 'load-dialog'
  });
}
export function uploader(data) {
  return request({
    url: 'BaseUploader/Simple',
    method: 'post',
    data: data,
    loadTarget: 'load-dialog'
  });
}

export function inReviewer(fileID) {
  return request({
    url: 'StockBills/InReviewer?FileID=' + fileID,
    method: 'get',
    loadTarget: 'load-dialog'
  });
}


export function outReviewer(fileID) {
  return request({
    url: 'StockBills/OutReviewer?FileID=' + fileID,
    method: 'get',
    loadTarget: 'load-dialog'
  });
}


export function resolveTable(file) {
  var dataList = new FormData();
  dataList.append(file.name, file.raw);
  //dataList.append("fileType", fileType || "excel");
  //dataList.append("dataType", dataType || "simpleUploader");

  return request({
    url: 'Common/ResolveTable',
    method: 'post',
    data: dataList,
    loadTarget: 'load-dialog'
  });
}